/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PlanDay_Input } from './PlanDay_Input';
export type OptimizePlanRequest = {
    days: Array<PlanDay_Input>;
    optimize: OptimizePlanRequest.optimize;
};
export namespace OptimizePlanRequest {
    export enum optimize {
        SIMULATION_ONLY = 'simulation_only',
        OPTIMIZE = 'optimize',
        OPTIMIZE_SIMPLE = 'optimize_simple',
        OPTIMIZE_CATEGORY = 'optimize_category',
        OPTIMIZE_CATEGORY_WITH_USER_PLAN = 'optimize_category_with_user_plan',
    }
}

